export default "__VITE_ASSET__Xc94x6J9__"